import { withLDConsumer } from "launchdarkly-react-client-sdk";
import _ from "lodash";
import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import Reflux from "reflux";
import { withTranslation } from "react-i18next";

import {
  CustomerSucessController,
  Store__System,
  trackEvent,
  ModalConfirm
} from "@talentbait/shared-components";
import {
  CampaignCreationStore,
  MediaLibraryStore,
  PreviewStore,
  QualificationQuestionsStore,
  StatusStore,
  TempDraftCreationStore
} from "../../../Stores";
import { defaultTeaserTemplates } from "../../../Stores/PreviewStore";
import logger from "../../../utils/LoggerFrontend";

import Actions from "../../../Actions";
import BookingSwitcher from "../../Campaign/Campaign__BookingSwitcher.jsx";
import CampaignBudgetCalculator from "../../Campaign/Campaign__Budget-Calculator.jsx";

import LoadingView from "../../../Components/LoadingView/LoadingView";
import CampaignModalPreview from "../../Campaign/Campaign__ModalPreviews.jsx";
import CampaignCreateBaseData from "../campaign-creation/campaign-base-data/CampaignCreateBaseData";
import CampaignAgencyFinished from "../CampaignAgencyFinished.jsx";
import BookingFinished from "./booking-finished/BookingFinished";
import CampaignCreatePackages from "../Campaign__Create_Packages.jsx";
import CampaignCreatePreviewsStep from "../Previews/Campaign__Create_Previews_Step.jsx";
import CampaignCreateATS from "../QualificationQuestions/Campaign__Create_ATS.jsx";
import { getPermissions } from "../../../Permissions/index.js";
import { saveUserFlatLogService } from "../../../services/UserLogFlatService.js";
import { getLeadFormLink, getMinimumClicks } from "../../../utils/Helpers";
import { preparePostsForSaving, simpleCleanTitle } from "../Previews/utils";
import { prepareAtsDoc } from "../QualificationQuestions/utils";
import CampaignCreateNavigation from "./navigation/CampaignCreateNavigation";
import RightSideBar from "./right-sidebar/RightSideBar";
import { BOOKING_STEPS } from "./utils/constants";
import MediaAssets from "./media-assets/MediaAssets";
import BookingOverview from "./booking-overview/BookingOverview.jsx";
import { callWebUtils } from "../../../Components/CampaignMembers/helpers";
import { notifyAddOnsOnSlack } from "../campaign-creation/utils/notifyAddOnsOnSlack.js";
import {
  ANALYSIS_FEEDBACK_VIDEO_REVIEW_POSITION_ID,
  ANALYSIS_OPTIMIZATION_VIDEO_REVIEW_POSITION_ID,
  SPOTIFY_HUMAN_VOICE_POSITION_ID
} from "./booking-overview/BookingOverview.constants.js";
import { ActionsTempDraftCreation } from "../../../Actions/ActionsTempDraftCreation/ActionsTempDraftCreation";
import { ActionsMediaAssetsLab } from "../../../Actions/ActionsMediaAssetsLab/ActionsMediaAssetsLab";
import { getSelectedChannelsList } from "./utils/getSelectedChannels.js";

// https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
const beforeUnloadListener = (event) => {
  event.preventDefault();
  // This custom message is not supported for newer browsers, they will use their own one
  return (event.returnValue = "Changes that you made may not be saved.");
};

Reflux.initStore(PreviewStore);
Reflux.initStore(MediaLibraryStore);
Reflux.initStore(QualificationQuestionsStore);

class SelfServiceCampaignCreate extends Reflux.Component {
  constructor(props) {
    super(props);

    this.state = {
      draftButtonDisabled: false,
      wrongOrgaModalOpen: false
    };

    this.stores = [
      Store__System,
      StatusStore,
      CampaignCreationStore,
      PreviewStore,
      QualificationQuestionsStore,
      TempDraftCreationStore
    ];

    this.handleLoadDraftCampaign = Actions.loadDraftCampaign.completed.listen(
      ({ organizationId = "", channels }) => {
        if (organizationId) {
          Actions.loadOrganizationOfCampaign(organizationId);
        }

        if (channels) {
          const transformedChannels = channels.map((channel) => ({
            channel_short_name: channel
          }));

          this.setState({
            recommendedChannels: transformedChannels,
            selectedChannels: transformedChannels,
            initiallyRecommendedChannels: channels
          });
        }
      }
    );

    this.draftCreationCompleted = Actions.createCampaignDraft.completed.listen((result) => {
      const { organization = {}, userProfile, tempDraftCampaignId } = this.state;
      logger.log("CampaignCreate:createCampaignDraft", "finished", {
        result,
        organization,
        userProfile
      });

      if (result.draftCampaignId) {
        ActionsMediaAssetsLab.updateCloudinaryMetadataCampaignId({
          campaignId: tempDraftCampaignId,
          newCampaignId: result.draftCampaignId
        });

        ActionsTempDraftCreation.changeTempDraftCampaignId(result.draftCampaignId);
      }

      this.setState({ draftButtonDisabled: false });

      if (organization.clientType === "ats-client") {
        Actions.loadCampaigns(
          userProfile?.organizationId,
          "ACTIVE_AND_IN_PROGRESS_AND_DRAFTS",
          "companyName",
          organization?.name
        );
      } else {
        Actions.loadCampaigns(
          userProfile?.organizationId,
          "ACTIVE_AND_IN_PROGRESS_AND_DRAFTS",
          "organizationId",
          userProfile?.organizationId
        );
      }
    });

    this.draftCreationFailed = Actions.createCampaignDraft.failed.listen((error) => {
      logger.log("error:CampaignCreate:createCampaignDraft", "failed", { error });
      this.setState({ draftButtonDisabled: false });
    });

    this.createCampaignCompleted = Actions.createCampaignAndSave.completed.listen(
      async ({ payload = {} }) => {
        const { campaignId, allowMultipleCreativesPerPost, campaignInvoiceAddOns } = payload;
        const { draftCampaignId } = this.state;
        const firstAdset = payload?.adsets?.[0] ?? {};
        const { adsetId, channelCampaigns } = firstAdset;

        logger.log("CampaignCreate:createCampaignAndSave", "completed called", {
          payload,
          campaignId,
          campaignInvoiceAddOns,
          draftCampaignId
        });

        ActionsMediaAssetsLab.updateCloudinaryMetadataCampaignId({
          campaignId: draftCampaignId,
          newCampaignId: campaignId
        });

        ActionsTempDraftCreation.changeTempDraftCampaignId(campaignId);

        const {
          jobCategoryId,
          campaignGoal,
          organization: {
            id: orgaId = "",
            applicationEmail = "",
            subdomain,
            name: orgaName,
            shouldAutoGenerateCampaignText
          },
          // Preview data
          posts,
          channelsData,
          userProfile,
          // Qualifications question data
          questions,
          selectedChatbotQuestion,
          formality,
          atsId,
          jobTitle,
          // Campaign data
          jobPostingUrl,
          location,
          selectedChannels,
          lifeTimeBudget,
          campaignDuration
        } = this.state;

        const { userName, userId, email } = userProfile;

        const analysisOptimizationCost = campaignInvoiceAddOns?.find(
          ({ id }) => id === ANALYSIS_OPTIMIZATION_VIDEO_REVIEW_POSITION_ID
        );

        const analysisFeedbackCost = campaignInvoiceAddOns?.find(
          ({ id }) => id === ANALYSIS_FEEDBACK_VIDEO_REVIEW_POSITION_ID
        );

        const spotifyHumanVoiceCost = campaignInvoiceAddOns?.find(
          ({ id }) => id === SPOTIFY_HUMAN_VOICE_POSITION_ID
        );

        logger.log("CampaignCreate:createCampaignAndSave", "video review options " + campaignId, {
          campaignId,
          adsetId,
          orgaId,
          campaignInvoiceAddOns
        });

        if (analysisOptimizationCost || analysisFeedbackCost || spotifyHumanVoiceCost) {
          notifyAddOnsOnSlack({
            Actions,
            userName,
            userId,
            email,
            orgaName,
            orgaId,
            campaignId,
            analysisOptimizationCost: analysisOptimizationCost?.price,
            analysisFeedbackCost: analysisFeedbackCost?.price,
            spotifyHumanVoiceCost: spotifyHumanVoiceCost?.price
          });
        }

        let previewPosts = preparePostsForSaving({
          posts,
          channelsData,
          campaignId,
          username: userProfile.username,
          createReleased: false
        });

        previewPosts = (previewPosts || []).map((post) => ({
          ...post,
          campaignId,
          releasedVersion: (post.releasedVersion || 0) + 1,
          stagingVersion: 0
        }));

        logger.log("CampaignCreate:createCampaignAndSave", "saving posts " + campaignId, {
          campaignId,
          adsetId,
          channelCampaigns,
          previewPosts,
          posts,
          channelsData,
          formality,
          questions,
          selectedChatbotQuestion,
          orgaId
        });

        if (!previewPosts.length) {
          return;
        }

        const cleanJobTitle = simpleCleanTitle(this.state.jobTitle);
        logger.log("CampaignCreate:createCampaignAndSave", "created clean job title", {
          jobTitle: this.state.jobTitle,
          cleanJobTitle,
          campaignId
        });

        previewPosts.forEach((post) => {
          const channelCampaignIds = channelCampaigns
            .filter((channelCampaign) => channelCampaign.channel == post.channel)
            .map((channelCampaign) => channelCampaign.id);
          post.campaignId = campaignId;
          post.adsetId = adsetId || null;
          post.channelCampaignIds = channelCampaignIds || [];
          post.orgaId = orgaId;
          post.releasedVersion = 1;
          post.stagingVersion = 0;

          post.channelData.cleanJobTitle = cleanJobTitle || this.state.jobTitle;

          if (campaignGoal === "applicants" && jobCategoryId) {
            post.channelData.url = getLeadFormLink({
              jobCategoryId,
              campaignId,
              subdomain,
              baseUrlTalentBait: window?.config?.baseUrlTalentBait,
              channel: post.channel
            });
          }
        });

        const duplicateMediaAssets = async (mediaAssetIds) => {
          let newMediaAssets = [];

          const context = {
            failed: () => {
              return newMediaAssets;
            },
            completed: ({ payload }) => {
              newMediaAssets = payload;
              return newMediaAssets;
            }
          };
          const mediaAssetsIdsToDuplicate = { mediaAssetIds: mediaAssetIds };

          await callWebUtils(context, "duplicateMultipleMediaAssets", [mediaAssetsIdsToDuplicate]);
          return newMediaAssets;
        };

        const releasedPosts = await Promise.all(
          previewPosts.map(async (post) => {
            const oldMediaAssetsId = post.mediaAssets?.map((mediaAssetId) => mediaAssetId) || [];
            const newMediaAssetIdResponse = oldMediaAssetsId.length
              ? await duplicateMediaAssets(oldMediaAssetsId)
              : null;

            return {
              ...post,
              mediaAssets: newMediaAssetIdResponse?.duplicatedMediaAssetIds || [],
              type: "released"
            };
          })
        );

        // Register handler
        Actions.saveAdCreatives.failed.listen((error) => {
          logger.log(
            "error:CampaignCreate:createCampaignAndSave:saveAdCreatives",
            "Faild to save ad creatives",
            {
              campaignId,
              adsetId,
              channelCampaigns,
              releasedPosts,
              error
            }
          );
        });

        Actions.saveAdCreatives.completed.listen(() => {
          logger.log(
            "CampaignCreate:createCampaignAndSave:saveAdCreatives:completed",
            "saved ad creatives.",
            { campaignId }
          );

          if (campaignGoal === "applicants") {
            logger.log(
              "CampaignCreate:createCampaignAndSave:saveAdCreatives:completed",
              "generating teaser text",
              { campaignId }
            );
            Actions.generateTextRecommendation({ campaignId });
          }
        });

        logger.log("CampaignCreate:createCampaignAndSave", "Start saving ad creatives", {
          campaignId,
          adsetId,
          channelCampaigns,
          releasedPosts
        });

        let adCreatives = previewPosts.concat(releasedPosts);

        for (const adCreative of adCreatives) {
          if (!allowMultipleCreativesPerPost) {
            adCreative.creatives = [adCreative.creatives[0]];
          }

          if (adCreative.isAutoGenerationStreaming || !adCreative.teaserText) {
            adCreative.isAutoGenerated = false;
            adCreative.teaserText = defaultTeaserTemplates[0].replace("{{jobTitle}}", jobTitle);
            delete adCreative.autoGeneratedText;

            if (adCreative.channel === "google-search") {
              delete adCreative.autoTitle;
              delete adCreative.autoTitle2;
              delete adCreative.autoTitle3;

              adCreative.title = "Stellentitel";
              adCreative.title2 = "Headline 2";
              adCreative.title3 = "Headline 3";
            }
          }

          delete adCreative.isAutoGenerationStreaming;
        }

        logger.log("CampaignCreate:createCampaignAndSave", "Call now", {
          campaignId,
          adsetId
        });

        Actions.saveAdCreatives(adCreatives, campaignId);

        if (campaignGoal === "applicants" && campaignId) {
          const { organization = {} } = this.state;
          const defaultATSLogo = organization?.companyLogo || null;
          const atsCampaignData = { companyLogo: defaultATSLogo, teaserImage: defaultATSLogo };

          const atsData = prepareAtsDoc({
            formality,
            questions,
            selectedChatbotQuestion,
            orgaId,
            applicationEmail,
            campaignData: atsCampaignData
          });

          Actions.updateAtsWithCampaignId.failed.listen((error) => {
            logger.log(
              "error:CampaignCreate:createCampaignAndSave:updateAtsWithCampaignId",
              "Faild to update ats values",
              { campaignId, atsData, error }
            );
          });

          Actions.updateAtsWithCampaignId(campaignId, atsData);

          // Move over auto generated job page data to new campaign
          Actions.moveCampaignATSSettings(atsId, campaignId);

          // Delete shadow campaign used for saving job page data
          Actions.deleteDraftCampaign(atsId);
        }

        trackEvent({
          event: "Campaign Booked",
          userId: userProfile.userId,
          properties: {
            organization_id: orgaId,
            organization_name: orgaName,
            user_name: userProfile.userName,
            user_id: userProfile.userId,
            ai_description: shouldAutoGenerateCampaignText,
            job_title: jobTitle,
            job_url: jobPostingUrl,
            campaign_id: campaignId,
            selected_channels: selectedChannels.map((channel) => channel.channel_short_name),
            campaign_duration: campaignDuration,
            locations: location.map((location) => location.label),
            min_clicks: this.calcMinClicks(lifeTimeBudget, selectedChannels),
            life_time_Budget: lifeTimeBudget
          },
          context: { id: orgaId },
          path: "Campaign__Create.jsx/createCampaignAndSave"
        });

        saveUserFlatLogService({
          userProfile,
          orgaId,
          orgaName,
          actionType: "create_campaign",
          message: `User finished booking campaign: ${jobTitle} in organization: ${orgaName}`
        });
      }
    );

    this.createCampaignFailed = Actions.createCampaignAndSave.failed.listen((error) => {
      logger.log("error:CampaignCreate:createCampaignAndSave", "failed", {
        error,
        posts: this.state.posts,
        channelsData: this.state.channelsData
      });
    });

    this.handlePicturesAdded = this.handlePicturesAdded.bind(this);
    this.handleChangeWillUpload = this.handleChangeWillUpload.bind(this);
    this.handleChangeCanUseWebsitePics = this.handleChangeCanUseWebsitePics.bind(this);
  }

  componentDidMount() {
    logger.log("CampaignCreate:componentDidMount", "called", { props: this.props });
    const { userProfile = {} } = this.state;
    const { organizationId } = userProfile;
    const { isBudgetCheck } = this.props;
    const { draftCampaignId } = this.props.match.params;

    Actions.getCampaignManager();
    Actions.loadOrganizationOfCampaign(organizationId);
    CustomerSucessController.send("CampaignCreate:started");

    if (isBudgetCheck) {
      Actions.campaignCreateUpdateBudgetData({ showDraftButton: false });
    } else {
      addEventListener("beforeunload", beforeUnloadListener);
    }

    if (draftCampaignId) {
      logger.log("CampaignCreate:loadDraftCampaign", "called", {
        draftCampaignId,
        campaignId: draftCampaignId
      });

      Actions.loadDraftCampaign(draftCampaignId, organizationId);
      Actions.getAtsData(draftCampaignId);

      // Prepopulate the preview store with the ad creatives saved on the db
      const budgetCheck = new URLSearchParams(this.props.location.search).get("budgetCheck");
      if (budgetCheck === "false") {
        const clientView = false;
        Actions.getCampaignAndAdCreativesByCampaignId(draftCampaignId, clientView, organizationId);
      } else {
        Actions.getCampaignAndAdCreativesByCampaignId(draftCampaignId, null, organizationId);
      }
    } else {
      Actions.clearDraftCampaign();
    }
  }

  componentWillUnmount() {
    Actions.campaignCreateResetData(this.state.locale);
    removeEventListener("beforeunload", beforeUnloadListener);

    this.handleLoadDraftCampaign();
    this.draftCreationCompleted();
    this.draftCreationFailed();
    this.createCampaignCompleted();
    this.createCampaignFailed();
  }

  componentDidUpdate(prevProps, prevState) {
    logger.debug("CampaignCreate:componentDidUpdate", "called", {
      prevState,
      state: this.state,
      prevProps,
      props: this.props
    });

    this.checkCampaignUserOrga();
    const { STEP_FINISHED_NEW, STEP_FINISHED, STEP_PREVIEWS_NEW, STEP_BASE_DATA } = BOOKING_STEPS;
    const { currentStep, budgetCheck, userProfile = {} } = this.state;
    const { organizationId } = userProfile;
    const { draftCampaignId } = this.props.match.params;
    const { isBudgetCheck } = this.props;

    const isFinishedStep = currentStep === STEP_FINISHED_NEW || currentStep === STEP_FINISHED;

    if (isBudgetCheck && this.state.showDraftButton) {
      this.setState({
        showDraftButton: false
      });
    }

    if (prevProps.match.params.draftCampaignId !== draftCampaignId) {
      logger.debug("CampaignCreate:fetchingdraft", "fetching", { draftCampaignId });

      if (organizationId) {
        Actions.loadDraftCampaign(draftCampaignId, organizationId);
        Actions.getAtsData(draftCampaignId);
      }
    }

    if (isFinishedStep) {
      logger.debug("CampaignCreate:beforeunload", "called", { draftCampaignId });

      removeEventListener("beforeunload", beforeUnloadListener);
    }

    if (
      (currentStep === STEP_PREVIEWS_NEW && (budgetCheck === undefined || budgetCheck)) ||
      (currentStep === STEP_BASE_DATA && budgetCheck)
    ) {
      this.setState({ budgetCheck: false });
    }

    const isBudgetCheckStep = currentStep === STEP_BASE_DATA || currentStep === STEP_PREVIEWS_NEW;

    if (!this.props?.location?.search.includes(currentStep)) {
      this.props.history.push({
        search:
          "?" +
          new URLSearchParams({ step: currentStep }) +
          "&" +
          new URLSearchParams({
            budgetCheck: isBudgetCheckStep ? false : budgetCheck
          }).toString()
      });
    }
  }

  checkCampaignUserOrga() {
    const { userProfile = {}, wrongOrgaModalOpen, campaignData } = this.state;
    const translation = this.props.t;

    // Check if userProfile and campaignData are not null or empty
    const isUserProfileEmpty = !userProfile || Object.keys(userProfile).length === 0;
    const isCampaignDataEmpty =
      !campaignData || Object.keys(campaignData).length === 0 || !campaignData?.organizationId;
    const isDataLoaded = !isUserProfileEmpty && !isCampaignDataEmpty;

    if (
      isDataLoaded &&
      userProfile.organizationId !== campaignData.organizationId &&
      !wrongOrgaModalOpen
    ) {
      this.setState({ wrongOrgaModalOpen: true });

      const actionCall = () => {
        this.setState({ wrongOrgaModalOpen: false });
        Actions.toggleModal("showGenericModal", false);

        this.props.history.push("/dashboard");
      };

      return Actions.toggleModal("showGenericModal", true, {
        headline: translation("You are not part of this organization"),
        widthVersion: "small",
        hideClose: true,
        view: (
          <ModalConfirm
            showDescription={true}
            subtitle=""
            labelConfirm={"Okay"}
            description={translation(
              "Contact your organization admin to get access to this campaign. You will be redirected to your dashboard."
            )}
            cancelledAction={() => {
              actionCall();
            }}
            confirmedAction={() => {
              actionCall();
            }}
          />
        )
      });
    }
  }

  getCompanyName() {
    const { organization, companyName } = this.state;
    let result = "";
    if (organization && companyName) result = companyName;
    else if (organization && organization.isAgency) result = "";
    else if (organization) result = organization.name;
    else result = companyName;
    logger.debug("CampaignCreate:getCompanyName", "returns", { result, organization, companyName });
    return result || "";
  }

  getCampaignGoal() {
    var { campaignGoal, organization } = this.state;

    var campaignGoalOnOrgaLevel = organization && organization.campaignGoal;

    return campaignGoalOnOrgaLevel || campaignGoal || "traffic";
  }

  handlePicturesAdded(photosArray) {
    logger.debug("CampaignCreate:handlePicturesAdded", "Added new photos", { photosArray });
    const newPic = photosArray[photosArray.length - 1];
    const { pictures = [] } = this.state;
    Actions.campaignCreateUpdatePreviewData({ pictures: [newPic].concat(pictures) });
  }

  handleChangedSelectedPicture(selectedImage) {
    logger.debug("CampaignCreate:handleChangedSelectedPicture", "selected new image", {
      selectedImage
    });
    let newPictures = [selectedImage];
    newPictures = _.uniqBy(newPictures, "image_url");
    Actions.campaignCreateUpdatePreviewData({ pictures: newPictures });
  }

  handleChangeWillUpload(value) {
    this.setState({ willUploadPicturesLater: value });
  }

  handleChangeCanUseWebsitePics(value) {
    this.setState({ canUseWebsitePictures: value });
  }

  onShowPreview(channel) {
    const { t } = this.props;

    logger.log("CampaignCreate:onShowPreview", "called...", channel);
    Actions.toggleModal("showGenericModal", true, {
      headline: t("Examples"),
      customWidth: "60%",
      onClose: this.onClosePreview.bind(this),
      view: (
        <div style={{ padding: 15 }}>
          <CampaignModalPreview selectedChannel={channel} />
        </div>
      )
    });

    CustomerSucessController.send("CampaignCreate:showPreview", {
      channel
    });
  }

  onClosePreview(e) {
    e.preventDefault();
    logger.log("CampaignCreate:onClosePreview", "called...");
    Actions.toggleModal("showGenericModal", false);

    CustomerSucessController.send("CampaignCreate:closePreview");
  }

  /**
   * Calculates the minimum clicks for the campaign
   * @param {number} budget Lifetime budget for the campaign
   * @param {object[]} selectedChannels Selected channels for the campaign
   * @returns {number} Minimum clicks for the campaign
   */
  calcMinClicks(budget, selectedChannels) {
    logger.debug("calcMinClicks", "called", {
      budget,
      selectedChannels,
      minClicksPackage: this.state.minClicksPackage
    });

    if (this.state.minClicksPackage) {
      return this.state.minClicksPackage;
    }

    return getMinimumClicks(budget, selectedChannels);
  }

  renderSidebar() {
    const { currentStep } = this.state;
    const { campaignCreationMediaAssets = false } = this.props.flags;

    return campaignCreationMediaAssets ? (
      <MediaAssets currentStep={currentStep} />
    ) : (
      <RightSideBar currentStep={currentStep} />
    );
  }

  onSaveDraft = () => {
    const {
      location,
      lifeTimeBudget,
      organization,
      campaignGoal,
      companyName,
      companyId,
      jobPostingUrl,
      jobTitle,
      selectedChannels = [],
      bookingStyle,
      jobCategoryId,
      predictions,
      minClicksPackage,
      campaignManager,
      packageId,
      currentStep,
      currentlySelectedAddress,
      nrOfDraft,
      draftLimit,
      poNumber,
      campaignDuration = 30,
      userProfile,
      draftCampaignId,
      // Preview data
      posts,
      channelsData,
      // Qualifications question data
      questions,
      selectedChatbotQuestion,
      startDate,
      formality,
      atsId,
      user,
      optimizeAnalysis,
      feedbackAnalysis,
      spotifyHumanVoice,
      isLoadingInvoiceAddresses,
      isFirstCampaign,
      locale
    } = this.state;

    logger.log("CampaignCreate:onSaveDraft", "init called", {
      posts,
      channelsData,
      currentlySelectedAddress
    });

    const orgaId = userProfile.organizationId;

    // Prepare ats data to save for draft
    const defaultATSLogo = organization?.companyLogo || null;
    const atsCampaignData = { companyLogo: defaultATSLogo, teaserImage: defaultATSLogo };

    const previewAtsData = prepareAtsDoc({
      formality,
      questions,
      selectedChatbotQuestion,
      orgaId,
      applicationEmail: organization?.applicationEmail,
      campaignData: atsCampaignData
    });

    const { userName, userId } = userProfile;

    if (!draftCampaignId && nrOfDraft >= draftLimit) {
      Actions.addNotification(
        "Maximum draft number is reached for your organization, we can not save a new draft",
        "error"
      );

      CustomerSucessController.send("CampaignCreate:draftLimitReached");
      return;
    }

    CustomerSucessController.send("CampaignCreate:draftCreated");

    CustomerSucessController.send("Campaign Draft Saved", {
      user_id: user?.uid,
      organization_id: organization?.id,
      user_name: user?.displayName,
      organization_name: organization?.name,
      ai_description: organization?.shouldAutoGenerateCampaignText,
      step: currentStep,
      job_title: jobTitle,
      job_url: jobPostingUrl,
      campaign_id: draftCampaignId,
      channels: selectedChannels
    });

    this.setState({ draftButtonDisabled: true });

    // Prepare ad creatives to save as drafts
    let previewPosts = preparePostsForSaving({
      posts,
      channelsData,
      campaignId: draftCampaignId,
      orgaId,
      username: userProfile.username,
      createReleased: false
    });

    previewPosts = (previewPosts || []).map((post) => ({
      ...post,
      campaignId: draftCampaignId,
      releasedVersion: (post.releasedVersion || 0) + 1,
      stagingVersion: 0
    }));

    const channels = _.map(selectedChannels, "channel_short_name");
    const draftData = {
      deployed: true,
      createdDate: new Date().toISOString(),
      jobTitle: jobTitle.trim(),
      campaignName: jobTitle.trim(),
      companyName: companyName.trim(),
      companyId: companyId,
      locations: location,
      jobPostingUrl: jobPostingUrl.trim(),
      selectedChannels,
      channels,
      lifeTimeBudget: String(lifeTimeBudget),
      source: "WEB_INTERFACE",
      campaignDuration,
      bookingStyle,
      lastEditStage: currentStep,
      status: "DRAFT",
      startDate,
      ...(jobCategoryId ? { jobCategoryId } : {}),
      ...(minClicksPackage ? { minClicksPackage } : {}),
      ...(predictions ? { predictions } : {}),
      ...(organization?.id ? { organizationId: organization?.id } : {}),
      ...(organization?.campaignGoal ? { campaignGoal: organization?.campaignGoal } : {}),
      ...(organization?.name ? { orgaName: organization?.name } : {}),
      ...(campaignManager?.id ? { campaignManager: campaignManager?.id } : {}),
      userName,
      userId,
      packageId,
      poNumber,
      sourceTrigger: "WEB_INTERFACE_2",
      optimizeAnalysis,
      feedbackAnalysis,
      spotifyHumanVoice,
      isLoadingInvoiceAddresses,
      isFirstCampaign,
      locale: locale || "de_DE"
    };

    logger.log("CampaignCreate:onSaveDraft", "called", { previewPosts, previewAtsData, draftData });

    if (campaignGoal == "applicants") {
      draftData.activeSourcingFeature = true;
    }

    if (draftCampaignId) {
      Actions.notifiyEvent({
        eventName: "entwurf",
        text: `📋 Draft campaign updated for *${jobTitle}*/${companyName} from *${userName}* (${organization.name}) `
      });
    } else {
      Actions.notifiyEvent({
        eventName: "entwurf",
        text: `📋 Draft campaign created for *${jobTitle}*/${companyName} from *${userName}* (${organization.name}) `
      });
    }

    Actions.createCampaignDraft({
      campaignGoal,
      draftData,
      draftCampaignId,
      previewPosts,
      previewAtsData,
      orgaId: organization?.id || orgaId,
      atsId
    });
  };

  onNextStep = async () => {
    const {
      currentStep,
      user,
      organization,
      jobTitle,
      jobPostingUrl,
      selectedChannels,
      draftCampaignId,
      campaignData
    } = this.state;

    let { campaignGoal } = this.state;

    const { STEP_REVIEW, STEP_PRICE_PACKAGE, STEP_PREVIEWS_NEW, STEP_BEWERBERHUB } = BOOKING_STEPS;
    const { campaignGoal: campaignGoalOnCampaignLevel } = campaignData;

    if (campaignGoalOnCampaignLevel) {
      campaignGoal = campaignGoalOnCampaignLevel;
    }

    const getNextStep = {
      STEP_BASE_DATA: STEP_PRICE_PACKAGE,
      STEP_PRICE_PACKAGE: STEP_PREVIEWS_NEW,
      STEP_PREVIEWS_NEW: campaignGoal === "traffic" ? STEP_REVIEW : STEP_BEWERBERHUB,
      STEP_BEWERBERHUB: STEP_REVIEW
    };

    CustomerSucessController.send("Campaign Creation Started", {
      user_id: user?.uid,
      organization_id: organization?.id,
      user_name: user?.displayName,
      organization_name: organization?.name,
      ai_description: organization?.shouldAutoGenerateCampaignText,
      step: currentStep,
      job_title: jobTitle,
      job_url: jobPostingUrl,
      campaign_id: draftCampaignId,
      channels: selectedChannels
    });

    Actions.campaignCreateUpdateBudgetData({ currentStep: getNextStep[currentStep] });
  };

  onHoverErrorMessage() {
    const {
      currentStep,
      user,
      organization,
      jobTitle,
      jobPostingUrl,
      selectedChannels,
      draftCampaignId,
      adErrors
    } = this.state;

    CustomerSucessController.send("Text Error Message", {
      user_id: user?.uid,
      organization_id: organization?.id,
      user_name: user?.displayName,
      organization_name: organization?.name,
      ai_description: organization?.shouldAutoGenerateCampaignText,
      step: currentStep,
      job_title: jobTitle,
      job_url: jobPostingUrl,
      campaign_id: draftCampaignId,
      channels: selectedChannels,
      message: adErrors.errorMessage
    });
  }

  render() {
    const {
      // Main user data
      organization,
      user,
      userProfile,
      // View data
      currentStep,
      bookingStyle,
      disableChangingBookingStyle,
      errorMsg,
      errorLoadingCampaigns,
      // Campaign data
      campaignId,
      adsetId,
      campaignGoal,
      jobPostingUrl,
      jobTitle,
      location,
      activeDate,
      startDate,
      selectedChannels,
      recommendedChannels,
      lifeTimeBudget,
      predictions,
      jobCategoryId,
      packageId,
      pictures,
      // ML API
      jobCategory,
      willUploadPicturesLater,
      canUseWebsitePictures,
      campaignManager,
      campaignDuration,
      isBooking,
      isSavingPreviews,
      selfServiceBookingStyle,
      paymentStatus,
      isRemoteJob,
      createdDate,
      extraBudgetLocations,
      loadingDraft,
      draftCampaignId,
      atsId,
      showDraftButton = false,
      invoiceAddresses,
      currentlySelectedAddress,
      poNumber,
      paymentType,
      // Qualification Questions Store States
      questions,
      selectedChatbotQuestion,
      draftButtonDisabled,
      // Preview store
      posts,
      campaignBookingError,
      adErrors,
      loading,
      isLoadingInvoiceAddresses,
      optimizeAnalysis,
      feedbackAnalysis,
      spotifyHumanVoice,
      // Campaign Creation Store
      benefits,
      tasks,
      requirements,
      companyId,
      jobId,
      locale = "de_DE"
    } = this.state;

    const isLoadingCampaignAndAdCreatives = loading || isLoadingInvoiceAddresses;

    const {
      STEP_REVIEW,
      STEP_PRICE_PACKAGE,
      STEP_PREVIEWS_NEW,
      STEP_BEWERBERHUB,
      STEP_BASE_DATA,
      STEP_FINISHED,
      STEP_FINISHED_NEW
    } = BOOKING_STEPS;

    const { userName, userId, username, permissions } = userProfile || {};
    const { hasPermissionToCreateCampaign } = getPermissions(userProfile);

    if (!permissions) {
      return <LoadingView msg="Loading Permissions..." showSpinner />;
    }

    if (!hasPermissionToCreateCampaign) {
      <Redirect to="/" />;
    }

    const { isBudgetCheck, t } = this.props;

    logger.debug("CampaignCreate:render", "called", {
      bookingStyle,
      currentStep,
      companyName,
      companyNameCalc: this.getCompanyName(),
      userProfileId: userId,
      username,
      userName,
      organization,
      invoiceAddresses,
      questions,
      selectedChatbotQuestion,
      location,
      recommendedChannels,
      selectedChannels
    });

    const isOrganizationInformed = organization != null && Object.keys(organization).length > 0;
    const disableCampaignBooking = isOrganizationInformed && organization.disableCampaignBooking;

    if (!user) {
      logger.debug("CampaignCreate:render", "(1)");
      return <Redirect to="/login" />;
    }

    if (loadingDraft || !isOrganizationInformed || _.isEmpty(userProfile || !invoiceAddresses)) {
      return <LoadingView msg="Loading..." showSpinner />;
    }

    if (disableCampaignBooking) {
      return <LoadingView msg="Loading view..." showSpinner />;
    }

    if (errorLoadingCampaigns) {
      return <LoadingView msg={errorLoadingCampaigns} showSpinner={false} />;
    }

    if (currentStep === STEP_REVIEW && isLoadingCampaignAndAdCreatives) {
      return <LoadingView msg={`${t("Loading invoice addresses")}...`} showSpinner />;
    }

    const nextStep = { currentStep: STEP_BEWERBERHUB };
    const orgaId = userProfile.organizationId;

    if (campaignGoal == "traffic") {
      nextStep.currentStep = STEP_REVIEW;
    }

    const orgaName = (organization && organization.name) || "not set";
    const companyName = this.getCompanyName();

    const navigationSteps =
      currentStep === STEP_BASE_DATA ||
      currentStep === STEP_PRICE_PACKAGE ||
      currentStep === STEP_PREVIEWS_NEW ||
      currentStep === STEP_BEWERBERHUB ||
      currentStep === STEP_REVIEW;

    return (
      <>
        {navigationSteps && (
          <CampaignCreateNavigation
            disableDraft={draftButtonDisabled}
            adErrors={adErrors}
            draftCampaignId={draftCampaignId}
            onSaveDraft={this.onSaveDraft}
            onNextStep={this.onNextStep}
            currentStep={currentStep}
            campaignGoal={campaignGoal}
            isLoadingBooking={isBooking || isSavingPreviews}
            disabledBooking={
              (paymentType == "invoice" && !currentlySelectedAddress) || campaignBookingError
            }
          />
        )}

        <div className="campaign-creation fade-in" style={{ position: "relative" }}>
          {currentStep == STEP_BASE_DATA && organization && (
            <CampaignCreateBaseData
              isBudgetCheck={isBudgetCheck}
              userName={userName}
              userId={userId}
            />
          )}
          {(isBudgetCheck || bookingStyle === "new") && currentStep == STEP_PRICE_PACKAGE && (
            <CampaignBudgetCalculator
              onShowPreview={this.onShowPreview.bind(this)}
              calcMinClicks={this.calcMinClicks.bind(this)}
              isBudgetCheck={isBudgetCheck}
            >
              {this.renderSidebar()}
            </CampaignBudgetCalculator>
          )}
          {!isBudgetCheck && bookingStyle === "old" && currentStep == STEP_PRICE_PACKAGE && (
            <CampaignCreatePackages>{this.renderSidebar()}</CampaignCreatePackages>
          )}
          {currentStep === STEP_PREVIEWS_NEW && (
            <CampaignCreatePreviewsStep
              orgaId={orgaId}
              companyName={companyName}
              companyId={companyId}
              orgaName={orgaName}
              userId={userId}
              userName={userProfile?.username}
              selectedChannels={selectedChannels}
              jobTitle={jobTitle}
              location={location}
              jobPostingUrl={jobPostingUrl}
              jobCategoryId={jobCategoryId}
              campaignId={draftCampaignId || atsId}
              organization={organization}
              sentences={{ benefits, tasks, requirements }}
              locale={locale}
            >
              {this.renderSidebar()}
            </CampaignCreatePreviewsStep>
          )}
          {currentStep == STEP_BEWERBERHUB && (
            <CampaignCreateATS
              campaignId={draftCampaignId}
              orgaId={orgaId}
              viewType="booking"
              // Props for showing next step
              userProfile={userProfile}
              jobTitle={jobTitle}
              location={location}
              startDate={startDate}
              jobPostingUrl={jobPostingUrl}
              lifeTimeBudget={lifeTimeBudget}
              companyName={companyName}
              selfServiceBookingStyle={selfServiceBookingStyle}
              showDraftButton={showDraftButton}
              campaignDuration={campaignDuration}
              campaignLanguage={locale}
            >
              {this.renderSidebar()}
            </CampaignCreateATS>
          )}

          {currentStep === STEP_REVIEW && (
            <BookingOverview
              activeDate={activeDate}
              bookingStyle={bookingStyle}
              campaignBookingError={campaignBookingError}
              campaignDuration={campaignDuration}
              campaignGoal={campaignGoal}
              campaignManager={campaignManager}
              canUseWebsitePictures={canUseWebsitePictures}
              companyName={companyName}
              companyId={companyId}
              currentlySelectedAddress={currentlySelectedAddress}
              draftCampaignId={draftCampaignId}
              extraBudgetLocations={extraBudgetLocations}
              invoiceAddresses={invoiceAddresses}
              isBooking={isBooking}
              isRemoteJob={isRemoteJob}
              jobCategory={jobCategory}
              jobCategoryId={jobCategoryId}
              jobPostingUrl={jobPostingUrl}
              jobTitle={jobTitle}
              lifeTimeBudget={lifeTimeBudget}
              location={location}
              minClicks={this.calcMinClicks(lifeTimeBudget, selectedChannels)}
              orgaId={orgaId}
              packageId={packageId || "NO_PACKAGE_NAME_DEFINED"}
              paymentStatus={paymentStatus || ""}
              paymentType={paymentType}
              pictures={pictures}
              poNumber={poNumber}
              posts={posts}
              predictions={predictions}
              selectedChannelList={getSelectedChannelsList(
                packageId,
                lifeTimeBudget,
                selectedChannels
              )}
              selectedChannels={selectedChannels}
              recommendedChannels={recommendedChannels}
              selfServiceBookingStyle={selfServiceBookingStyle}
              startDate={startDate}
              willUploadPicturesLater={willUploadPicturesLater}
              optimizeAnalysis={optimizeAnalysis}
              feedbackAnalysis={feedbackAnalysis}
              spotifyHumanVoice={spotifyHumanVoice}
              organization={organization}
              jobId={jobId}
            />
          )}

          {currentStep === STEP_FINISHED_NEW && (
            <CampaignAgencyFinished
              campaignId={campaignId}
              createdDate={createdDate}
              startDate={startDate}
              orgaId={orgaId}
              userProfile={userProfile}
              adsetId={adsetId}
            />
          )}
          {currentStep === STEP_FINISHED && <BookingFinished campaignId={campaignId} />}

          {errorMsg && <div className="error">{errorMsg}</div>}
          <br />
          <br />
          <br />
        </div>

        {!isBudgetCheck &&
          !disableChangingBookingStyle &&
          currentStep == STEP_PRICE_PACKAGE &&
          organization.isAgency && (
            <div>
              <BookingSwitcher bookingStyle={bookingStyle} onSwitch={Actions.switchBookingStyle} />
            </div>
          )}
      </>
    );
  }
}

export default withLDConsumer()(withRouter(withTranslation()(SelfServiceCampaignCreate)));
